module.exports = __webpack_public_path__ + "img/gsb32.2e330eb3.png";